import CategoriesItem from "../CategoriesItem.jsx";
import Footer from "../Footer.jsx";
import Newsletter from "../Newsletter.jsx";

function All() {
  return (
    <>
      <CategoriesItem />
      <Newsletter />
      <Footer />
    </>
  );
}

export default All;
